import { excuseApi } from '../commons/http';

class DailyCheckIn {
  fetchStatus() {
    return excuseApi({
      method: 'GET',
      path: '/accounts/check-in/status',
    });
  }

  checkIn() {
    return excuseApi({
      method: 'POST',
      path: '/accounts/check-in',
    });
  }

  checkOut() {
    return excuseApi({
      method: 'POST',
      path: '/accounts/check-out',
    });
  }

  fetchHistory(params = {}) {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      per_page: params.perPage || 10,
      ...(params.startDate && { start_date: params.startDate }),
      ...(params.endDate && { end_date: params.endDate }),
    }).toString();

    return excuseApi({
      method: 'GET',
      path: `/accounts/check-in/history?${queryParams}`,
    });
  }

  fetchById(id) {
    return excuseApi({
      method: 'GET',
      path: `/accounts/check-in/${id}`,
    });
  }
}

export default DailyCheckIn; 